export default "__VITE_ASSET__D6lCP62C__$_?no-inline__"